import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { api } from '@/lib/api'
import { Globe, Mail, Loader2, User } from 'lucide-react'

interface PublicAccount {
  id: string
  display_name: string | null
  plan: string
  created_at: string
}

export function PublicProfile() {
  const { accountId } = useParams<{ accountId: string }>()
  const [account, setAccount] = useState<PublicAccount | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!accountId) return
    api.get(`/auth/public/${accountId}`)
      .then((res) => setAccount(res.data))
      .catch(() => setError('Account not found or not public'))
      .finally(() => setLoading(false))
  }, [accountId])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-violet-400" />
      </div>
    )
  }

  if (error || !account) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <Card className="w-full max-w-md">
          <CardContent className="p-6 text-center">
            <p className="text-muted-foreground">{error || 'Account not found'}</p>
          </CardContent>
        </Card>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background px-4 py-12">
      <div className="max-w-md mx-auto space-y-6">
        <div className="text-center space-y-2">
          <div className="h-16 w-16 rounded-full bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center mx-auto">
            <User className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-xl font-bold">{account.display_name || 'PurpleToad Mail User'}</h1>
          <p className="text-sm text-muted-foreground capitalize">{account.plan} Plan</p>
        </div>

        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">Account Info</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm">
            <div className="flex items-center gap-2">
              <Globe className="h-4 w-4 text-muted-foreground" />
              <span className="text-muted-foreground">Member since</span>
              <span className="ml-auto">{new Date(account.created_at).toLocaleDateString()}</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-muted-foreground" />
              <span className="text-muted-foreground">Plan</span>
              <span className="ml-auto capitalize">{account.plan}</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
